export * from './PropertyDetails'
